import { PORTFOLIO_BUILDER, MODEL_PORTFOLIO_BUILDER, PORTFOLIO_BUILDER_EDITOR } from './constants'


export function modelPortofolioRouteNamesConfig(flowType) {
  return [
    `${PORTFOLIO_BUILDER}-${flowType}-step-model-portfolio`,
    `${PORTFOLIO_BUILDER}-${flowType}-step-conformation`
  ]
}

function modelPortofolioBuilder(pages, flowType) {
  return {
    path: flowType,
    name: `${PORTFOLIO_BUILDER}-${flowType}`,
    component: pages.portfolioEditor,
    redirect: {
      name: `${PORTFOLIO_BUILDER}-${flowType}-step-model-portfolio`
    },
    children: [
      {
        path: '',
        name: `${PORTFOLIO_BUILDER}-${flowType}-step-model-portfolio`,
        component: pages.portfolioEditorStepPortfolio,
        meta: {
          pos: 1,
          hiddenHeader: true
        },
        redirect: {
          name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-model-portfolio`
        },
        children: [
          {
            path: `model-portfolio`,
            name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-model-portfolio`,
            props: true,
            meta: {
              hiddenHeader: true
            },
            component: pages.portfolioEditorModelPortfolio
          },
          {
            path: `allocation`,
            name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-allocation`,
            props: true,
            meta: {
              hiddenHeader: true
            },
            component: pages.portfolioEditorAllocation
          },
          {
            path: `risk`,
            name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-risk`,
            props: true,
            meta: {
              hiddenHeader: true
            },
            component: pages.portfolioEditorRisk
          },
          {
            path: `backtest`,
            name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-backtest`,
            props: true,
            meta: {
              hiddenHeader: true
            },
            component: pages.portfolioEditorBacktest
          },
          {
            path: `esg`,
            name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-esg`,
            props: true,
            meta: {
              hiddenHeader: true
            },
            component: pages.portfolioEditorEsg
          }
        ]
      },
      {
        path: 'funds-list-modification',
        name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-funds-list-modification`,
        component: pages.customerAllocationRecomendationFundsListModification,
        meta: {
          isStepperVisible: false,
          hiddenHeader: true
        }
      },
      {
        path: 'confirmation',
        name: `${PORTFOLIO_BUILDER}-${flowType}-step-conformation`,
        component: pages.portfolioEditorStepConfirmation,
        meta: {
          pos: 2,
          hiddenHeader: true
        }
      },
      {
        path: 'funds-details',
        name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-funds-details`,
        component: pages.customerAllocationFund,
        redirect: { name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-funds-details-overview` },
        props: true,
        children: [
          {
            path: 'overview',
            name: `${PORTFOLIO_BUILDER_EDITOR}-${flowType}-funds-details-overview`,
            meta: { hiddenHeader: true },
            component: pages.fundOverview
          }
        ]
      }
    ]
  }
}

export default (pages, authenticatedRoutes) => {
  return {
    path: `/${PORTFOLIO_BUILDER}`,
    name: `/${PORTFOLIO_BUILDER}-authentificated`,
    meta: {
      portfolioBuilder: true,
      authenticated: true
    },
    component: pages.portfolioBuilderPage,
    redirect: {
      name: `${PORTFOLIO_BUILDER}-products`
    },
    children: [
      {
        path: `products`,
        name: `${PORTFOLIO_BUILDER}-products`,
        component: pages.portfolioBuilderContracts
      },
      {
        path: `support`,
        name: `${PORTFOLIO_BUILDER}-support`,
        component: pages.advisorySupport
      },
      {
        path: 'funds-details',
        name: `model-portfolio-funds-details`,
        component: pages.customerAllocationFund,
        redirect: { name: 'model-portfolio-funds-details-overview' },
        props: true,
        children: [
          {
            path: 'overview',
            name: 'model-portfolio-funds-details-overview',
            component: pages.fundOverview
          }
        ]
      },
      {
        path: `product/:productId`,
        component: pages.portfolioBuilderProductDetails,
        redirect: {
          name: `${PORTFOLIO_BUILDER}-product-model-portfolios-list`
        },
        children: [
          {
            path: `model-portfolios-list`,
            name: `${PORTFOLIO_BUILDER}-product-model-portfolios-list`,
            props: true,
            component: pages.portfolioBuilderProductModelPortfolios
          },
          modelPortofolioBuilder(pages, 'add'),
          {
            path: `funds-universe`,
            name: `${PORTFOLIO_BUILDER}-product-funds-universe`,
            props: true,
            component: pages.portfolioBuilderProductFondsUniverse
          },
          {
            path: 'model-portfolio/:modelPortfolioId',
            name: `${MODEL_PORTFOLIO_BUILDER}-detail`,
            component: pages.portfolioBuilderModelPortfolioDetail,
            redirect: {
              name: `${MODEL_PORTFOLIO_BUILDER}-investment`
            },
            children: [
              modelPortofolioBuilder(pages, 'edit'),
              {
                path: 'investment',
                name: `${MODEL_PORTFOLIO_BUILDER}-investment`,
                component: pages.portfolioBuilderModelPortfolioDetailInvestment
              },
              {
                path: 'repartition',
                name: `${MODEL_PORTFOLIO_BUILDER}-repartition`,
                component: pages.portfolioBuilderModelPortfolioDetailRepartition
              },
              {
                path: 'esg',
                name: `${MODEL_PORTFOLIO_BUILDER}-esg`,
                component: pages.portfolioBuilderModelPortfolioDetailEsg
              },
              {
                path: 'backtest',
                name: `${MODEL_PORTFOLIO_BUILDER}-backtest`,
                component: pages.portfolioBuilderModelPortfolioDetailBacktest
              },
              {
                path: 'contract',
                name: `${MODEL_PORTFOLIO_BUILDER}-contract`,
                component: pages.portfolioBuilderModelPortfolioDetailContract
              },
            ]
          }
        ]
      }
    ]
  }
}
